import { createContext, useContext, useEffect, useState } from 'react';
import { public_api } from '@/lib/api';

const ContentContext = createContext({});

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  useEffect(() => {
    public_api.content().then(setContent).catch(() => {});
  }, []);
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export function useContent() {
  const content = useContext(ContentContext);
  return (key, fallback = '') => content[key] || fallback;
}
